import { Spinner } from '@scale/scaleui';
import { useFetchUserInfo } from 'react-scale/components/ExpertManagement/hooks/queries/useFetchUserInfo';
import {
  useUserInfoStore,
  userInfoSelector,
} from 'react-scale/components/ExpertManagement/stores/userInfo.store';
import { shallow } from 'zustand/shallow';
import { IndividualExpertPage } from './IndividualExpertPage';
import ManagerPage from './ManagerPage';

interface UserPageProps {
  userId: string;
}

const UserPage: React.FC<UserPageProps> = ({ userId }: UserPageProps) => {
  const { isLoading } = useFetchUserInfo(userId);
  const userInfo = useUserInfoStore(userInfoSelector, shallow);

  if (isLoading || !userInfo) {
    return (
      <div className="p-4">
        <Spinner size="md" />
      </div>
    );
  }
  if (!userInfo.role || userInfo.role === 'Expert') {
    return <IndividualExpertPage />;
  } else {
    return <ManagerPage />;
  }
};

export default UserPage;
